import { useRef } from 'react';
import { getActiveSpace } from 'redux/Studio';
import { messageTextChanged } from 'web-ui-kit/conversation-events';

const SAVED_MESSAGE_KEY_RICH_TEXT = 'MESSENGER_SAVED_MESSAGE_RICH_TEXT';
const SAVED_MESSAGE_KEY_STRING = 'MESSENGER_SAVED_MESSAGE_STRING';

const saveMessageInLocalStorage = async ({ key, message }) => {
  try {
    window.localStorage.setItem(key, message);
  } catch (e) {
    // We really don't need to log this here since this happens for valid reasons
    // we just don't want the page to error
  }
};

const getKey = ({ isRichText, projectId }) => {
  // Returns the local storage key for the space and text type
  return `${projectId}${isRichText ? SAVED_MESSAGE_KEY_RICH_TEXT : SAVED_MESSAGE_KEY_STRING}`;
};

export const updateMessageInLocalStorage = ({ message, isRichText }) => async (dispatch, getState) => {
  const activeSpace = getActiveSpace({ state: getState() });
  // Retrieve the correct local storage key by the message type
  const key = getKey({ isRichText, projectId: activeSpace && activeSpace.id() });
  await saveMessageInLocalStorage({ key, message });
};

const updateSavedDraftJSState = (draftJSObj) => ({
  type: 'set-saved-draft-js-state',
  payload: draftJSObj
});

/**
 * Small hook to retrieve and save the current message text in local storage
 */
export default function useSavedMessage ({ dispatch, isRichText, loading, projectId }) {
  // We only want to retrieve from storage on page load
  const pageHasLoadedFromStorage = useRef(false);

  if (typeof window === 'undefined') {
    // Early exit if we're on the server
    return;
  }
  if (!pageHasLoadedFromStorage.current && !loading) {
    // Attempt to load value from storage
    const key = getKey({ isRichText, projectId });
    try {
      const message = window.localStorage.getItem(key) || '';
      // Update state with the stored value
      if (message) {
        const updateAction = isRichText
          ? updateSavedDraftJSState(JSON.parse(message))
          : messageTextChanged({ messageText: message });
        dispatch(updateAction);
      }
    } catch (e) {
      // We really don't need to log this here since this happens for valid reasons
      // we just don't want the page to error
    }
    // Tell the hook not to load from storage again
    pageHasLoadedFromStorage.current = true;
  }
}
